
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap-guest');
require('./material');
require('select2');

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate);

Vue.component('register-user', require('./components/user/RegisterUser').default);
Vue.component('reset_password', require('./components/auth/PasswordReset').default);
Vue.component('twofactorauth', require('./components/auth/TwoFactorAuth').default);

Vue.component('alert', require('./components/shared/Alert.vue').default);

const app = new Vue({
    el: '.main',
});
